import { useState, useEffect } from 'react';
import { StorageKey } from '../utils/helper.type';

/**
 * Custom hook to retrieve and format organization unit data from localStorage.
 *
 * - Fetches organization unit data stored in `organizationUnitDatas` key.
 * - Parses the data and joins the names of organization units with a comma.
 * - Handles errors gracefully and returns an empty string if parsing fails.
 *
 * @returns A string containing the names of organization units joined by a comma.
 */
const useOrganizationUnitData = (): string => {
  const [organizationUnit, setOrganizationUnit] = useState<string>('');

  useEffect(() => {
    const getOrganizationUnit = (): string => {
      try {
        const storedData = localStorage.getItem(
          StorageKey.ORGANIZATION_UNIT_DATA,
        );
        if (storedData) {
          const organizationUnits = JSON.parse(storedData);
          return organizationUnits
            .map((unit: { name: string }) => unit.name)
            .join(', ');
        }
      } catch (error) {
        console.error(
          `Error parsing ${StorageKey.ORGANIZATION_UNIT_DATA} from localStorage:`,
          error,
        );
      }
      return '';
    };

    setOrganizationUnit(getOrganizationUnit());
  }, []);

  return organizationUnit;
};

export default useOrganizationUnitData;
